import script from "./VideoLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoLabel.vue?vue&type=script&setup=true&lang=js"

import "./VideoLabel.vue?vue&type=style&index=0&id=7b9b6007&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9b6007"]])

export default __exports__